export default {
  hertz: "#FFCC00",
  hertzHover: "#FFDE56",
  ace: "#01396c",
  aceHover: "#0079e8",
  aceText: "#ffffff",
  firefly: "#9757a6",
  fireflyHover: "#d57aeb",
  fireflyText: "#ffffff",
  disabled: "#a8a8a8",
  ninetyBlack: "#434244",
  eightyBlack: "#58595b",
  sixtyBlack: "#808285",
  lightGrey: "#f0f0f0",
  dollar:"#c8102e",
  dollarHover:"#a50d27",
  dollarText:"#ffffff",
  thrifty:"#007AC3",
  thriftyHover:"#006199",
  thriftyText:"#ffffff"
};
